import { createFileRoute } from '@tanstack/react-router'
import { CreateOrgScreen } from '@/screens/accounts/SCR-110-create-org'

// SCR-110 Create an organisation (accounts area).
export const Route = createFileRoute('/_public/create-org')({
  component: CreateOrgScreen,
})
